import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { UserNewPassword, UserSimple } from '../../../model/user';
import { UserPasswordResetActionTypes } from './types';

export const resetPasswordRequest = (password: UserNewPassword) => action(UserPasswordResetActionTypes.USER_RESET_PASSWORD_REQUEST, password);
export const resetPasswordSuccess = (user: UserSimple) => action(UserPasswordResetActionTypes.USER_RESET_PASSWORD_SUCCESS, user);
export const resetPasswordError = (error: GiroWebappError) => action(UserPasswordResetActionTypes.USER_RESET_PASSWORD_ERROR, error);